// Form validation for New Milestone form
import { plaintextValidator } from '../fields';

const config = { mandatory: true };

export default {
  name: plaintextValidator(config)
};
